import {
    UPDATEUSERINFO_REQUEST,
    UPDATEUSERINFO_SUCCESS,
    UPDATEUSERINFO_FAILURE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    updateUserInfoStatus: [],
    error: null,
};

export default function updateUserInfoReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATEUSERINFO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case UPDATEUSERINFO_SUCCESS:
            return {
                ...state,
                // always replacing data
                updateUserInfoStatus: action.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case UPDATEUSERINFO_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
